export default [{
  path: '/courseManager',
  name: 'courseManager',
  component: resolve => require(['@/views/course/courseManager/courseManager.vue'], resolve),
  meta: {
    group: "/courseManager",
    isLoginAuthority: true // 需要登录权限才能访问
  }
}, {
  path: '/addCourse',
  name: 'addCourse',
  component: resolve => require(['@/views/course/courseManager/addCourse.vue'], resolve),
  meta: {
    group: "/courseManager",
    isLoginAuthority: true // 需要登录权限才能访问
  }
}, {
  path: '/editCourse',
  name: 'editCourse',
  component: resolve => require(['@/views/course/courseManager/addCourse.vue'], resolve),
  meta: {
    group: "/courseManager",
    isLoginAuthority: true // 需要登录权限才能访问
  }
}, {
  path: '/courseClassify',
  name: 'courseClassify',
  component: resolve => require(['@/views/course/courseClassify/courseClassify.vue'], resolve),
  meta: {
    group: "/courseClassify",
    isLoginAuthority: true // 需要登录权限才能访问
  }
}, {
  path: '/courseOrder',
  name: 'courseOrder',
  component: resolve => require(['@/views/course/courseOrder/courseOrder.vue'], resolve),
  meta: {
    group: "/courseOrder",
    isLoginAuthority: true // 需要登录权限才能访问
  }
}]


// WEBPACK FOOTER //
// ./src/router/course/course.js